interface Props {}

export default function NotFoundPage(_: Props) {
  return <div>Page not found</div>;
}
